import type { ReactElement } from 'react';
import { Outlet, ScrollRestoration } from 'react-router';
import { GuestQuoteClaimNotice, usePendingGuestQuoteClaim } from '@/features/guest-quote-claim';
import { KakaoChatButton } from '@/widgets/kakao-chat-button';

/**
 * 앱 셸 — 라우터 맨 위 한 겹(모든 화면의 부모). 비회원 견적 연결 훅(결정 G11)을 여기 한 번만 건다.
 * 로그인·가입·소셜 콜백·온보딩 어디로 가든, 계정이 ACTIVE 가 되는 순간 [주문하기]로 기억한 견적을 연결한다.
 * 연결 결과 안내도 이 한곳에 띄운다. AppProviders 는 RouterProvider 바깥이라 이동 훅을 쓸 수 없어 여기 둔다.
 * 스크롤 복원도 여기 한 번만 둔다 — 새 화면으로 가면 맨 위에서 시작하고, 뒤로·앞으로 가면 보던 위치로 돌아온다
 * (목록을 내려 보다 상품을 열었을 때 상세가 내려간 채 열리지 않게).
 * 카카오톡 상담 버튼도 여기 한 번만 둔다 — 운영 설정에 채널 주소가 있을 때 모든 화면 오른쪽 아래에 뜬다.
 */
export const AppShell = (): ReactElement => {
  usePendingGuestQuoteClaim();

  return (
    <>
      <ScrollRestoration />
      <Outlet />
      <GuestQuoteClaimNotice />
      <KakaoChatButton />
    </>
  );
};
